<template>
    <div>
      <trademark-type-list></trademark-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  